export default {
    // Header Section
    "discover_your": "ನಿಮ್ಮ",
    "numerology": "ಸಂಖ್ಯಾಶಾಸ್ತ್ರವನ್ನು ಅನ್ವೇಷಿಸಿ",
    "numbers_reveal_destiny": "ಸಂಖ್ಯೆಗಳು ನಿಮ್ಮ ಭಾಗ್ಯವನ್ನು ಬಹಿರಂಗಪಡಿಸುತ್ತವೆ",
    "numerology_description": "ನಿಮ್ಮ ಜೀವನ ಮಾರ್ಗ, ಭಾಗ್ಯ ಸಂಖ್ಯೆ, ವ್ಯಕ್ತಿತ್ವ ಲಕ್ಷಣಗಳು ಮತ್ತು ನಿಮ್ಮ ಪ್ರಯಾಣವನ್ನು ರೂಪಿಸುವ ದೈವಿಕ ಸಂಖ್ಯಾತ್ಮಕ ಪ್ರಭಾವಗಳನ್ನು ಒಳಗೊಂಡ ಸಮಗ್ರ ಸಂಖ್ಯಾಶಾಸ್ತ್ರ ವಿಶ್ಲೇಷಣೆಯೊಂದಿಗೆ ನಿಮ್ಮ ಜೀವನದಲ್ಲಿನ ಸಂಖ್ಯೆಗಳ ನಿಗೂಢ ಶಕ್ತಿಯನ್ನು ಬಿಚ್ಚಿಡಿ.",

    // Service Information
    "enter_details_for_numerology": "ಸಂಖ್ಯಾಶಾಸ್ತ್ರಕ್ಕಾಗಿ ನಿಮ್ಮ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ",
    "complete_numerology_analysis": "ಸಂಪೂರ್ಣ ಸಂಖ್ಯಾಶಾಸ್ತ್ರ ವಿಶ್ಲೇಷಣೆ",
    "service_price": "ಸೇವೆಯ ಬೆಲೆ",
    "comprehensive_numerology_analysis_note": "ನಿಮ್ಮ ಸಂಖ್ಯಾತ್ಮಕ ನೀಲನಕ್ಷೆಯ ಆಳವಾದ ಅಧ್ಯಯನ ಮತ್ತು ನಿಮ್ಮ ಜೀವನದ ದೈವಿಕ ಗಣಿತದ ಮಾದರಿಗಳನ್ನು ಅನ್ವೇಷಿಸಿ",

    // Form Fields
    "full_name": "ಪೂರ್ಣ ಹೆಸರು",
    "enter_full_name": "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
    "name_vibration_analysis": "ನಿಮ್ಮ ಹೆಸರು ನಿಮ್ಮ ಭಾಗ್ಯದ ಮೇಲೆ ಪ್ರಭಾವ ಬೀರುವ ನಿರ್ದಿಷ್ಟ ಸಂಖ್ಯಾತ್ಮಕ ಕಂಪನಗಳನ್ನು ಹೊಂದಿದೆ",
    "email_address": "ಇಮೇಲ್ ವಿಳಾಸ",
    "enter_email_address": "ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",
    "phone_number": "ದೂರವಾಣಿ ಸಂಖ್ಯೆ",
    "enter_phone_number": "ನಿಮ್ಮ ದೂರವಾಣಿ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    "gender": "ಲಿಂಗ",
    "male": "ಪುರುಷ",
    "female": "ಮಹಿಳೆ",
    "other": "ಇತರೆ",
    "date_of_birth": "ಜನ್ಮ ದಿನಾಂಕ",
    "birth_date_life_path_number": "ನಿಮ್ಮ ಜನ್ಮ ದಿನಾಂಕ ನಿಮ್ಮ ಜೀವನ ಮಾರ್ಗ ಸಂಖ್ಯೆ ಮತ್ತು ಮೂಲ ಜೀವನ ಉದ್ದೇಶವನ್ನು ಬಹಿರಂಗಪಡಿಸುತ್ತದೆ",
    "preferred_language": "ಆದ್ಯತೆಯ ಭಾಷೆ",
    "english": "ಇಂಗ್ಲಿಷ್",
    "hindi": "ಹಿಂದಿ",
    "telugu": "ತೆಲುಗು",
    "kannada": "ಕನ್ನಡ",
    "language_note": "ಆಯ್ಕೆಮಾಡಿದ ಭಾಷೆಯಲ್ಲಿ ನಿಮ್ಮ ಸಂಖ್ಯಾಶಾಸ್ತ್ರ ವಿಶ್ಲೇಷಣೆಯನ್ನು ವಿತರಿಸಲಾಗುವುದು",

    // Core Numerology Features
    "life_path_number_analysis": "ಜೀವನ ಮಾರ್ಗ ಸಂಖ್ಯೆ ವಿಶ್ಲೇಷಣೆ",
    "destiny_number_insights": "ಭಾಗ್ಯ ಸಂಖ್ಯೆ ಒಳನೋಟಗಳು",
    "personality_number_traits": "ವ್ಯಕ್ತಿತ್ವ ಸಂಖ್ಯೆ ಲಕ್ಷಣಗಳು",
    "lucky_numbers_and_colors": "ಅದೃಷ್ಟದ ಸಂಖ್ಯೆಗಳು ಮತ್ತು ಬಣ್ಣಗಳು",
    "career_compatibility_numbers": "ವೃತ್ತಿ ಹೊಂದಾಣಿಕೆ ಸಂಖ್ಯೆಗಳು",
    "pdf_download": "ಸಮಗ್ರ PDF ವರದಿ",

    "what_you_get": "ನಿಮ್ಮ ಸಂಖ್ಯಾಶಾಸ್ತ್ರ ವಿಶ್ಲೇಷಣೆಯಲ್ಲಿ ಏನು ಸೇರಿದೆ",
    "complete_numerology_chart": "ಸಂಪೂರ್ಣ ಸಂಖ್ಯಾಶಾಸ್ತ್ರ ಚಾರ್ಟ್",
    "core_numbers_analysis": "ಮೂಲ ಸಂಖ್ಯೆಗಳ ವಿವರಣೆ",
    "personal_year_predictions": "ವೈಯಕ್ತಿಕ ವರ್ಷದ ಮುನ್ಸೂಚನೆ",
    "compatibility_insights": "ಸಂಖ್ಯಾತ್ಮಕ ಹೊಂದಾಣಿಕೆ ಮಾರ್ಗದರ್ಶಿ",

    // Actions & Buttons
    "pay_and_generate_analysis": "ನನ್ನ ಸಂಖ್ಯಾಶಾಸ್ತ್ರ ವಿಶ್ಲೇಷಣೆ ಪಡೆಯಿರಿ",
    "processing_payment": "ಪಾವತಿ ಸಂಸ್ಕರಿಸುತ್ತಿದೆ",
    "processing_request": "ವಿಶ್ಲೇಷಣೆ ರಚಿಸುತ್ತಿದೆ",

    // Payment & Success Messages
    "thank_you": "ಧನ್ಯವಾದಗಳು",
    "payment_successful": "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಿದೆ!",
    "numerology_analysis_processing": "ನಿಮ್ಮ ಸಂಖ್ಯಾಶಾಸ್ತ್ರ ವಿಶ್ಲೇಷಣೆಯನ್ನು ನಮ್ಮ ಪರಿಣಿತ ಸಂಖ್ಯಾಶಾಸ್ತ್ರಜ್ಞರು ಲೆಕ್ಕಾಚಾರ ಮಾಡುತ್ತಿದ್ದಾರೆ. ನಿಮ್ಮ ಸಂಖ್ಯಾತ್ಮಕ ನೀಲನಕ್ಷೆಯ ಬಗ್ಗೆ ವಿಸ್ತೃತ ಒಳನೋಟಗಳನ್ನು ನೀವು ಸ್ವೀಕರಿಸುತ್ತೀರಿ.",
    "order_id": "ಆರ್ಡರ್ ID",
    "payment_id": "ಪಾವತಿ ID",
    "amount_paid": "ಪಾವತಿಸಿದ ಮೊತ್ತ",

    // Delivery Information
    "delivery_information": "ವಿತರಣಾ ಮಾಹಿತಿ",
    "delivery_time": "ವಿಶ್ಲೇಷಣೆ ವಿತರಣೆ",
    "within_12_hours_delivery_note": "ನಿಮ್ಮ ವಿಸ್ತೃತ ಸಂಖ್ಯಾಶಾಸ್ತ್ರ ವರದಿ ೧೨ ಗಂಟೆಗಳೊಳಗೆ ಸಿದ್ಧವಾಗುತ್ತದೆ",
    "whatsapp_notification": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳು",
    "whatsapp_delivery_note": "WhatsApp ನಲ್ಲಿ ತಕ್ಷಣ ಅಧಿಸೂಚನೆಗಳನ್ನು ಸ್ವೀಕರಿಸಿ",
    "email_delivery": "ಇಮೇಲ್ ವಿತರಣೆ",
    "email_delivery_note": "ಸಂಪೂರ್ಣ ವಿಶ್ಲೇಷಣೆಯನ್ನು ಕಳುಹಿಸಲಾಗಿದೆ",

    // What You'll Receive
    "what_youll_receive": "ನಿಮ್ಮ ಸಂಖ್ಯಾಶಾಸ್ತ್ರ ವಿಶ್ಲೇಷಣೆ ಪ್ಯಾಕೇಜ್",
    "detailed_numerology_report": "ಸಮಗ್ರ ಸಂಖ್ಯಾಶಾಸ್ತ್ರ ವರದಿ (PDF)",
    "life_path_destiny_analysis": "ಜೀವನ ಮಾರ್ಗ ಮತ್ತು ಭಾಗ್ಯ ಸಂಖ್ಯೆ ವಿಶ್ಲೇಷಣೆ",
    "personal_numbers_meanings": "ವೈಯಕ್ತಿಕ ಸಂಖ್ಯೆಗಳು ಮತ್ತು ಅವುಗಳ ಅರ್ಥಗಳು",
    "lucky_elements_guidance": "ಅದೃಷ್ಟದ ಅಂಶಗಳು ಮತ್ತು ಮಾರ್ಗದರ್ಶನ",
    "annual_forecast_insights": "ವಾರ್ಷಿಕ ಸಂಖ್ಯಾಶಾಸ್ತ್ರ ಮುನ್ಸೂಚನೆ",

    // Visual Content
    "sample_numerology_analysis": "ಮಾದರಿ ಸಂಖ್ಯಾಶಾಸ್ತ್ರ ವಿಶ್ಲೇಷಣೆ",
    "life_path_number": "ಜೀವನ ಮಾರ್ಗ ಸಂಖ್ಯೆ",
    "sample_life_path_description": "ಅನ್ವೇಷಕ - ವಿಶ್ಲೇಷಣಾತ್ಮಕ, ಆಧ್ಯಾತ್ಮಿಕ ಮತ್ತು ಅಂತರ್ಮುಖಿ ಸ್ವಭಾವ",
    "sample_numerology_description": "ವಿಸ್ತೃತ ಒಳನೋಟಗಳೊಂದಿಗೆ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಸಂಖ್ಯಾತ್ಮಕ ವಿಶ್ಲೇಷಣೆಯ ಪೂರ್ವವೀಕ್ಷಣೆ",
    "core_numbers": "ಮೂಲ ಸಂಖ್ಯೆಗಳು",

    // Core Number Types
    "life_path": "ಜೀವನ ಮಾರ್ಗ",
    "destiny": "ಭಾಗ್ಯ",
    "personality": "ವ್ಯಕ್ತಿತ್ವ",
    "soul_urge": "ಆತ್ಮದ ಪ್ರೇರಣೆ",
    "birthday": "ಜನ್ಮದಿನ",
    "maturity": "ಪ್ರಾಪ್ತತೆ",

    // Status & Processing
    "your_numerology_analysis_status": "ನಿಮ್ಮ ಸಂಖ್ಯಾಶಾಸ್ತ್ರ ವಿಶ್ಲೇಷಣೆ ಸ್ಥಿತಿ",
    "processing_your_analysis": "ನಿಮ್ಮ ಸಂಖ್ಯೆಗಳನ್ನು ಲೆಕ್ಕಾಚಾರ ಮಾಡುತ್ತಿದೆ",
    "analysis_processing_message": "ನಮ್ಮ ಸಂಖ್ಯಾಶಾಸ್ತ್ರ ಪರಿಣಿತರು ನಿಮ್ಮ ಸಂಖ್ಯಾತ್ಮಕ ಮಾದರಿಗಳನ್ನು ವಿಶ್ಲೇಷಿಸುತ್ತಿದ್ದಾರೆ ಮತ್ತು ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಒಳನೋಟಗಳನ್ನು ತಯಾರಿಸುತ್ತಿದ್ದಾರೆ.",
    "request_id": "ವಿಶ್ಲೇಷಣೆ ID",
    "status": "ಸ್ಥಿತಿ",
    "processing": "ಪ್ರಗತಿಯಲ್ಲಿದೆ",
    "pending": "ಸರದಿಯಲ್ಲಿದೆ",
    "email_notification_sent": "ದೃಢೀಕರಣ ಇಮೇಲ್ ಕಳುಹಿಸಲಾಗಿದೆ",
    "whatsapp_update_coming": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳು ಸಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ",
    "delivery_within_12_hours": "ವರದಿ ೧೨ ಗಂಟೆಗಳೊಳಗೆ ಸಿದ್ಧ",

    // Support & Contact
    "contact_support": "ಸಂಖ್ಯಾಶಾಸ್ತ್ರ ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ",
    "need_help": "ಮಾರ್ಗದರ್ಶನ ಬೇಕೇ?",
    "contact_us_at": "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",

    // Error Messages
    "please_fill_all_required_fields": "ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಅಗತ್ಯ ವಿವರಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ",
    "payment_failed": "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "processing_failed": "ವಿಶ್ಲೇಷಣೆ ಸಂಸ್ಕರಣೆ ವಿಫಲವಾಗಿದೆ. ನಮ್ಮ ಬೆಂಬಲ ತಂಡವನ್ನು ಸಂಪರ್ಕಿಸಿ.",

    // Core Numerology Numbers
    "destiny_number": "ಭಾಗ್ಯ ಸಂಖ್ಯೆ",
    "personality_number": "ವ್ಯಕ್ತಿತ್ವ ಸಂಖ್ಯೆ",
    "soul_urge_number": "ಆತ್ಮದ ಪ್ರೇರಣೆ ಸಂಖ್ಯೆ",
    "birthday_number": "ಜನ್ಮದಿನ ಸಂಖ್ಯೆ",
    "maturity_number": "ಪ್ರಾಪ್ತತೆ ಸಂಖ್ಯೆ",
    "expression_number": "ಅಭಿವ್ಯಕ್ತಿ ಸಂಖ್ಯೆ",
    "heart_desire_number": "ಹೃದಯದ ಬಯಕೆ ಸಂಖ್ಯೆ",

    // Number Meanings (1-9)
    "number_1_meaning": "ನಾಯಕತ್ವ, ಸ್ವಾತಂತ್ರ್ಯ, ಪಥಪ್ರದರ್ಶಕ",
    "number_2_meaning": "ಸಹಕಾರ, ಪಾಲುದಾರಿಕೆ, ರಾಜತಂತ್ರ",
    "number_3_meaning": "ಸೃಜನಶೀಲತೆ, ಅಭಿವ್ಯಕ್ತಿ, ಸಂವಹನ",
    "number_4_meaning": "ಸ್ಥಿರತೆ, ಕಠಿಣ ಪರಿಶ್ರಮ, ಅಡಿಪಾಯ",
    "number_5_meaning": "ಸ್ವಾತಂತ್ರ್ಯ, ಸಾಹಸ, ಬದಲಾವಣೆ",
    "number_6_meaning": "ಪೋಷಣೆ, ಜವಾಬ್ದಾರಿ, ಚಿಕಿತ್ಸೆ",
    "number_7_meaning": "ಆಧ್ಯಾತ್ಮಿಕತೆ, ವಿಶ್ಲೇಷಣೆ, ಜ್ಞಾನ",
    "number_8_meaning": "ಭೌತಿಕ ಯಶಸ್ಸು, ಅಧಿಕಾರ, ಸಾಧನೆ",
    "number_9_meaning": "ಮಾನವೀಯತೆ, ಪೂರ್ಣತೆ, ಸೇವೆ",

    // Master Numbers
    "master_number_11": "ಮಾಸ್ಟರ್ ಸಂಖ್ಯೆ ೧೧ - ಅಂತಃಪ್ರಜ್ಞೆ ಮತ್ತು ಪ್ರೇರಣೆ",
    "master_number_22": "ಮಾಸ್ಟರ್ ಸಂಖ್ಯೆ ೨ೂ - ಮಾಸ್ಟರ್ ಬಿಲ್ಡರ್",
    "master_number_33": "ಮಾಸ್ಟರ್ ಸಂಖ್ಯೆ ೩೩ - ಮಾಸ್ಟರ್ ಶಿಕ್ಷಕ",

    // Personality & Character Analysis
    "core_personality_traits": "ಮೂಲ ವ್ಯಕ್ತಿತ್ವ ಗುಣಗಳು",
    "strengths_and_talents": "ನೈಸರ್ಗಿಕ ಶಕ್ತಿಗಳು ಮತ್ತು ಪ್ರತಿಭೆಗಳು",
    "challenges_to_overcome": "ಜಯಿಸಬೇಕಾದ ಸವಾಲುಗಳು",
    "life_lessons": "ಪ್ರಮುಖ ಜೀವನ ಪಾಠಗಳು",
    "inner_motivation": "ಅಂತರ್ಗತ ಪ್ರೇರಣೆಗಳು",
    "outer_expression": "ಇತರರು ನಿಮ್ಮನ್ನು ಹೇಗೆ ನೋಡುತ್ತಾರೆ",

    // Life Path Analysis
    "life_purpose": "ಜೀವನ ಉದ್ದೇಶ ಮತ್ತು ಧ್ಯೇಯ",
    "career_guidance": "ವೃತ್ತಿ ಮಾರ್ಗ ಮಾರ್ಗದರ್ಶನ",
    "relationship_patterns": "ಸಂಬಂಧದ ಮಾದರಿಗಳು",
    "financial_tendencies": "ಹಣ ಮತ್ತು ಹಣಕಾಸು ಪ್ರವೃತ್ತಿಗಳು",
    "health_insights": "ಆರೋಗ್ಯ ಮತ್ತು ಕಲ್ಯಾಣ ಒಳನೋಟಗಳು",
    "spiritual_journey": "ಆಧ್ಯಾತ್ಮಿಕ ಅಭಿವೃದ್ಧಿ ಮಾರ್ಗ",

    // Compatibility Analysis
    "love_compatibility": "ನಿಮ್ಮ ಪ್ರೇಮ ಜೀವನ",
    "friendship_compatibility": "ಸ್ನೇಹ ಹೊಂದಾಣಿಕೆ",
    "business_compatibility": "ವ್ಯಾಪಾರ ಪಾಲುದಾರಿಕೆ ಹೊಂದಾಣಿಕೆ",
    "family_dynamics": "ಕುಟುಂಬ ಸಂಬಂಧ ಡೈನಾಮಿಕ್ಸ್",
    "compatible_numbers": "ಹೆಚ್ಚು ಹೊಂದಾಣಿಕೆಯ ಸಂಖ್ಯೆಗಳು",
    "challenging_numbers": "ಸಂಭಾವ್ಯ ಸವಾಲಿನ ಸಂಖ್ಯೆಗಳು",

    // Lucky Elements
    "lucky_numbers": "ವೈಯಕ್ತಿಕ ಅದೃಷ್ಟದ ಸಂಖ್ಯೆಗಳು",
    "lucky_colors": "ಶುಭ ಬಣ್ಣಗಳು",
    "lucky_days": "ಅನುಕೂಲ ದಿನಗಳು",
    "lucky_gemstones": "ಪ್ರಯೋಜನಕಾರಿ ರತ್ನಗಳು",
    "lucky_directions": "ಅನುಕೂಲ ದಿಕ್ಕುಗಳು",
    "lucky_metals": "ಶುಭ ಲೋಹಗಳು",

    // Personal Year Analysis
    "current_personal_year": "ಪ್ರಸ್ತುತ ವೈಯಕ್ತಿಕ ವರ್ಷ",
    "personal_year_theme": "ವರ್ಷದ ವಿಷಯ ಮತ್ತು ಗಮನ",
    "monthly_guidance": "ತಿಂಗಳಿಗೆ-ತಿಂಗಳು ಮಾರ್ಗದರ್ಶನ",
    "opportunities_this_year": "ಪ್ರಮುಖ ಅವಕಾಶಗಳು",
    "challenges_this_year": "ಸಂಭಾವ್ಯ ಸವಾಲುಗಳು",
    "recommendations_this_year": "ವರ್ಷ-ವಿಶಿಷ್ಟ ಶಿಫಾರಸುಗಳು",

    // Name Analysis
    "name_numerology": "ಹೆಸರು ಸಂಖ್ಯಾಶಾಸ್ತ್ರ ವಿಶ್ಲೇಷಣೆ",
    "first_name_vibration": "ಮೊದಲ ಹೆಸರಿನ ಕಂಪನ",
    "last_name_influence": "ಉಪನಾಮದ ಪ್ರಭಾವ",
    "full_name_power": "ಸಂಪೂರ್ಣ ಹೆಸರಿನ ಶಕ್ತಿ",
    "nickname_effects": "ಅಡ್ಡಹೆಸರಿನ ಪರಿಣಾಮಗಳು",
    "name_change_suggestions": "ಹೆಸರು ಆಪ್ಟಿಮೈಸೇಶನ್ ಸಲಹೆಗಳು",

    // Birth Date Analysis
    "birth_date_significance": "ಜನ್ಮ ದಿನಾಂಕದ ಮಹತ್ವ",
    "day_vibration": "ದಿನ ಸಂಖ್ಯೆಯ ಪ್ರಭಾವ",
    "month_influence": "ಜನ್ಮ ತಿಂಗಳಿನ ಪರಿಣಾಮ",
    "year_energy": "ಜನ್ಮ ವರ್ಷದ ಶಕ್ತಿ",
    "complete_birth_pattern": "ಸಂಪೂರ್ಣ ಜನ್ಮ ಮಾದರಿ ವಿಶ್ಲೇಷಣೆ",

    // Karmic Numbers
    "karmic_debt_numbers": "ಕರ್ಮ ಋಣ ಸಂಖ್ಯೆಗಳು",
    "karmic_lessons": "ಕರ್ಮ ಜೀವನ ಪಾಠಗಳು",
    "soul_contracts": "ಆತ್ಮ ಒಪ್ಪಂದಗಳು ಮತ್ತು ಒಪ್ಪಂದಗಳು",
    "past_life_influences": "ಹಿಂದಿನ ಜನ್ಮದ ಸಂಖ್ಯಾತ್ಮಕ ಪ್ರಭಾವಗಳು",

    // Cycles & Periods
    "life_cycles": "ಪ್ರಮುಖ ಜೀವನ ಚಕ್ರಗಳು",
    "pinnacle_numbers": "ಶಿಖರ ಅವಧಿ ಸಂಖ್ಯೆಗಳು",
    "challenge_numbers": "ಸವಾಲು ಅವಧಿ ಸಂಖ್ಯೆಗಳು",
    "personal_months": "ವೈಯಕ್ತಿಕ ಮಾಸಿಕ ಚಕ್ರಗಳು",

    // Advanced Analysis
    "master_numbers_significance": "ನಿಮ್ಮ ಚಾರ್ಟ್‌ನಲ್ಲಿ ಮಾಸ್ಟರ್ ಸಂಖ್ಯೆಗಳು",
    "missing_numbers": "ಕಾಣೆಯಾದ ಸಂಖ್ಯೆಗಳ ವಿಶ್ಲೇಷಣೆ",
    "repeated_numbers": "ಪುನರಾವರ್ತಿತ ಸಂಖ್ಯೆಗಳ ಮಹತ್ವ",
    "intensity_table": "ಸಂಖ್ಯಾತ್ಮಕ ತೀವ್ರತೆ ವಿಶ್ಲೇಷಣೆ",

    // Practical Applications
    "best_dates_for_decisions": "ಪ್ರಮುಖ ನಿರ್ಧಾರಗಳಿಗಾಗಿ ಉತ್ತಮ ದಿನಾಂಕಗಳು",
    "timing_for_ventures": "ಹೊಸ ಉದ್ಯಮಗಳಿಗೆ ಅತ್ಯುತ್ತಮ ಸಮಯ",
    "home_address_analysis": "ಮನೆಯ ವಿಳಾಸ ಸಂಖ್ಯಾಶಾಸ್ತ್ರ",
    "phone_number_analysis": "ದೂರವಾಣಿ ಸಂಖ್ಯೆಯ ಕಂಪನಗಳು",
    "choosing_baby_names": "ಸಂಖ್ಯಾಶಾಸ್ತ್ರೀಯ ಮಗುವಿನ ಹೆಸರು ಮಾರ್ಗದರ್ಶನ",

    // Remedies & Recommendations
    "numerical_remedies": "ಸಂಖ್ಯಾಶಾಸ್ತ್ರೀಯ ಪರಿಹಾರಗಳು",
    "color_therapy": "ಬಣ್ಣ ಚಿಕಿತ್ಸೆ ಶಿಫಾರಸುಗಳು",
    "gemstone_suggestions": "ರತ್ನ ಶಿಫಾರಸುಗಳು",
    "mantras_for_numbers": "ಸಂಖ್ಯೆ-ವಿಶಿಷ್ಟ ಮಂತ್ರಗಳು",
    "meditation_techniques": "ಸಂಖ್ಯಾತ್ಮಕ ಧ್ಯಾನ ಅಭ್ಯಾಸಗಳು",

    // Business & Career
    "business_name_analysis": "ವ್ಯಾಪಾರ ಹೆಸರು ಸಂಖ್ಯಾಶಾಸ್ತ್ರ",
    "career_number_alignment": "ವೃತ್ತಿ-ಸಂಖ್ಯೆ ಹೊಂದಾಣಿಕೆ",
    "partnership_numbers": "ವ್ಯಾಪಾರ ಪಾಲುದಾರಿಕೆ ಸಂಖ್ಯೆಗಳು",
    "investment_timing": "ಹೂಡಿಕೆ ಸಮಯ ಮಾರ್ಗದರ್ಶನ",
    "product_launch_dates": "ಉತ್ಪನ್ನ ಲಾಂಚ್ ದಿನಾಂಕ ಆಯ್ಕೆ"
};
